<template>
  <div class="all">
    <div class="midd">
      <el-table ref="multipleTable" :data="tableData" border highlight-current-row height="100%">
        <template slot="empty">
          <img :src="zanwu" alt="" />
          <p style="font-size: 16px; color: #000; margin-top: 36px">暂无数据</p>
        </template>
        <el-table-column label="序号" align="center" type="index" width="60" />
        <el-table-column label="文件名称" prop="fileName" min-width="200px" />
        <el-table-column label="创建人" prop="operatorName" />
        <el-table-column label="上传时间" prop="uploadTime" min-width="120px" />
        <el-table-column label="最近更新时间" prop="updateTime" min-width="120px" />
        <el-table-column label="备注" prop="remark" min-width="200px" />
        <el-table-column label="操作" width="120px">
          <template slot-scope="scope">
            <span style="cursor: pointer;color:var(--theme-color)" @click="download(scope.row)">下载</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import standardFont from "@/CommonDP/service/standardFont-service";
import { getEnterpriseId } from "@/CommonDP/utils/auth";
export default {
  data() {
    return {
      zanwu: require("@/CommonDP/assets/暂无数据.png"),
      tableData: []
    };
  },
  computed: {
    enterpriseId() {
      return getEnterpriseId("enterpriseId");
    }
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 列表
    getList() {
      this.tableData = [];
      standardFont.selectStandardFontMaintenance(this.enterpriseId).then(({ data }) => {
        this.tableData = data || [];
      });
    },
    // 下载
    async download(row) {
      standardFont.downloadStandardFontFile(row.fileId).then((response) => {
        if (response.type === "application/json") {
          const fileReader = new FileReader();
          fileReader.onloadend = () => {
            const jsonData = JSON.parse(fileReader.result);
            // 后台信息
            this.$message({ message: jsonData.message, type: "error" });
          };
          fileReader.readAsText(response); // 或者读取response.data
        } else {
          const link = document.createElement("a");
          const blob = new Blob([response], {
            type: "application/octet-stream"
          });
          link.style.display = "none";
          link.href = URL.createObjectURL(blob);
          link.setAttribute("download", decodeURI(row.fileName));
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.all {
  height: 100%;
  position: relative;
  background-color: #fff;
}
.midd {
  position: absolute;
  top: 60px;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 4px 10px;
}
</style>
